import React from 'react'
import { useHighlightedText } from '../../hooks/useHighlightedText'
import '../../styles/HeadingModule/Subheading.scss'

export interface SubheadingProps {
  text: string
  className?: string
  id?: string
}

/**
 * Generic, presentational subheading: renders `text` (with `{highlight}` tokens
 * resolved) into a `<p>` with the given class.
 */
export const Subheading = ({ text, className = 'subheading', id }: SubheadingProps) => {
  return <p id={id} className={className}>{useHighlightedText(text)}</p>
}
